import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Access from "./public/Access";
import "./style.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Access />
  </StrictMode>,
);
